// ==========================================
// FIALLO - Main JavaScript
// ==========================================

// ==========================================
// SIDE MENU - ALD STYLE
// ==========================================
const menuToggle = document.querySelector('.menu-toggle');
const sideMenu = document.querySelector('.side-menu');
const sideMenuOverlay = document.querySelector('.side-menu-overlay');
const closeMenuBtn = document.querySelector('.close-menu');
const menuLinks = document.querySelectorAll('.menu-list a');
const menuTabs = document.querySelectorAll('.menu-tab');
const tabContents = document.querySelectorAll('.tab-content');

function openMenu() {
    sideMenu.classList.add('active');
    sideMenuOverlay.classList.add('active');
    menuToggle.classList.add('active-menu-toggle');
    document.body.style.overflow = 'hidden';
}

function closeMenu() {
    sideMenu.classList.remove('active');
    sideMenuOverlay.classList.remove('active');
    menuToggle.classList.remove('active-menu-toggle');
    document.body.style.overflow = '';
}

if (menuToggle) {
    menuToggle.addEventListener('click', (e) => {
        e.preventDefault();
        if (sideMenu.classList.contains('active')) {
            closeMenu();
        } else {
            openMenu();
        }
    });
}

if (closeMenuBtn) {
    closeMenuBtn.addEventListener('click', closeMenu);
}

// Close menu when clicking overlay
if (sideMenuOverlay) {
    sideMenuOverlay.addEventListener('click', closeMenu);
}

// Close menu when clicking on a link
menuLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
});

// Tab switching
menuTabs.forEach(tab => {
    tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tab;

        // Remove active from all tabs
        menuTabs.forEach(t => t.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));

        // Add active to clicked tab
        tab.classList.add('active');
        document.getElementById(`tab-${targetTab}`).classList.add('active');
    });
});

// ==========================================
// HEADER SCROLL EFFECT
// ==========================================
const header = document.querySelector('.header');
let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    // Add scrolled class to header (background bianco + logo piccolo)
    if (currentScrollY > 50) {
        header.classList.add('header--scrolled');
    } else {
        header.classList.remove('header--scrolled');
    }

    lastScrollY = currentScrollY;
});

// ==========================================
// HEADER TRANSPARENT OVER HERO (homepage only)
// Sections that should show the white-on-transparent header are tagged
// with .header-transparent-trigger (.hero-video-section, .lookbook-hero).
// When ANY of them is the dominant section in view, add .header--over-hero.
// NOTE: we target the SECTION, not the <video> — the hero can also be a
// still photo (see the "Use default hero video" setting), in which case
// there is no .hero-video element at all.
// ==========================================
(function () {
    var snap = document.querySelector('.home-snap-container');
    if (!snap || !header) return;

    var triggers = document.querySelectorAll('.hero-video-section, .lookbook-hero');
    if (!triggers.length) return;

    function updateOverHero() {
        var viewportH = window.innerHeight;
        var scrollTop = snap.scrollTop;
        var heroOver = false;

        triggers.forEach(function (el) {
            // Section's position within the snap container
            var top = el.offsetTop;
            var bottom = top + el.offsetHeight;
            // Activate when MORE than half of the section is in view
            var visibleStart = Math.max(top, scrollTop);
            var visibleEnd = Math.min(bottom, scrollTop + viewportH);
            var visible = Math.max(0, visibleEnd - visibleStart);
            if (visible > viewportH * 0.5) heroOver = true;
        });

        header.classList.toggle('header--over-hero', heroOver);
    }

    snap.addEventListener('scroll', updateOverHero, { passive: true });
    window.addEventListener('resize', updateOverHero);
    updateOverHero();
})();

// ==========================================
// EMAIL FORM SUBMISSION
// ==========================================
const emailForm = document.getElementById('emailForm');
const emailInput = document.getElementById('emailInput');
const formMessage = document.getElementById('formMessage');

if (emailForm) {
    emailForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const email = emailInput.value.trim();

        if (!email) {
            showFormMessage('Please enter a valid email address.', 'error');
            return;
        }

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showFormMessage('Please enter a valid email address.', 'error');
            return;
        }

        try {
            // TODO: Replace with actual API endpoint
            // For now, simulate a successful submission
            await simulateFormSubmission(email);

            showFormMessage('Thank you for joining! Check your inbox for exclusive content.', 'success');
            emailInput.value = '';

            // Store email in localStorage for demo purposes
            storeEmailSubscription(email);

        } catch (error) {
            showFormMessage('Something went wrong. Please try again later.', 'error');
            console.error('Form submission error:', error);
        }
    });
}

function showFormMessage(message, type) {
    formMessage.textContent = message;
    formMessage.className = `form-message ${type}`;

    // Clear message after 5 seconds
    setTimeout(() => {
        formMessage.textContent = '';
        formMessage.className = 'form-message';
    }, 5000);
}

async function simulateFormSubmission(email) {
    // Simulate API call
    return new Promise((resolve) => {
        setTimeout(() => {
            console.log('Email submitted:', email);
            resolve();
        }, 1000);
    });
}

function storeEmailSubscription(email) {
    const subscribers = JSON.parse(localStorage.getItem('fiallo_subscribers') || '[]');
    if (!subscribers.includes(email)) {
        subscribers.push(email);
        localStorage.setItem('fiallo_subscribers', JSON.stringify(subscribers));
    }
}

// ==========================================
// SMOOTH SCROLL FOR ANCHOR LINKS
// ==========================================
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');

        // Don't prevent default for # only links
        if (href === '#') return;

        e.preventDefault();

        const target = document.querySelector(href);
        if (target) {
            const headerHeight = header.offsetHeight;
            const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });
});

// ==========================================
// LAZY LOADING IMAGES
// ==========================================
if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                if (img.dataset.src) {
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                }
                observer.unobserve(img);
            }
        });
    });

    // Observe all images with data-src attribute
    document.querySelectorAll('img[data-src]').forEach(img => {
        imageObserver.observe(img);
    });
}

// ==========================================
// SHOPPING CART FUNCTIONALITY
// ==========================================
class ShoppingCart {
    constructor() {
        this.items = this.loadCart();
        this.updateCartCount();
    }

    loadCart() {
        const savedCart = localStorage.getItem('fiallo_cart');
        return savedCart ? JSON.parse(savedCart) : [];
    }

    saveCart() {
        localStorage.setItem('fiallo_cart', JSON.stringify(this.items));
    }

    addItem(product) {
        const existingItem = this.items.find(item => item.id === product.id);

        if (existingItem) {
            existingItem.quantity += 1;
        } else {
            this.items.push({
                ...product,
                quantity: 1
            });
        }

        this.saveCart();
        this.updateCartCount();
        this.showNotification(`${product.name} added to cart`);
    }

    removeItem(productId) {
        this.items = this.items.filter(item => item.id !== productId);
        this.saveCart();
        this.updateCartCount();
    }

    updateQuantity(productId, quantity) {
        const item = this.items.find(item => item.id === productId);
        if (item) {
            item.quantity = Math.max(0, quantity);
            if (item.quantity === 0) {
                this.removeItem(productId);
            } else {
                this.saveCart();
                this.updateCartCount();
            }
        }
    }

    getTotal() {
        return this.items.reduce((total, item) => {
            return total + (item.price * item.quantity);
        }, 0);
    }

    getItemCount() {
        return this.items.reduce((count, item) => count + item.quantity, 0);
    }

    updateCartCount() {
        // No-op on Shopify: .cart-count is rendered server-side via {{ cart.item_count }}.
        // Overwriting it from the local-storage cart would show wrong numbers.
    }

    showNotification(message) {
        // Create notification element
        const notification = document.createElement('div');
        notification.className = 'cart-notification';
        notification.textContent = message;
        notification.style.cssText = `
            position: fixed;
            top: 100px;
            right: 2rem;
            background: #000;
            color: #fff;
            padding: 1rem 2rem;
            border-radius: 4px;
            font-family: 'Aether Mono', monospace;
            font-size: 0.875rem;
            z-index: 10000;
            animation: slideIn 0.3s ease;
        `;

        document.body.appendChild(notification);

        // Remove after 3 seconds
        setTimeout(() => {
            notification.style.animation = 'slideOut 0.3s ease';
            setTimeout(() => {
                notification.remove();
            }, 300);
        }, 3000);
    }

    clear() {
        this.items = [];
        this.saveCart();
        this.updateCartCount();
    }
}

// Initialize cart (localStorage cart kept for legacy static pages only).
// On Shopify, the real cart is handled server-side via the /cart/add form action.
const cart = new ShoppingCart();

// NOTE: the click handler that previously intercepted .add-to-cart-btn submits
// was hijacking Shopify product forms and saving "undefined added to cart" into
// localStorage. Disabled. The form will POST normally to /cart/add.
// document.addEventListener('click', (e) => { ... });

// Cart button click - redirect to cart page
const cartBtn = document.querySelector('.cart-btn');
if (cartBtn) {
    cartBtn.addEventListener('click', () => {
        window.location.href = '/cart.html';
    });
}

// ==========================================
// ANIMATIONS ON SCROLL
// ==========================================
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, observerOptions);

// Observe elements for animation
document.querySelectorAll('.product-card, .about-content, .motorsport-content').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
});

// ==========================================
// HERO VIDEO — robust autoplay (mobile / iOS Low Power Mode safe)
// The <video> is class="hero-video" (no id). Native muted+playsinline
// autoplay can still be blocked (Low Power Mode, data saver, background
// tab), which makes the browser show its black poster + ▶ button. We keep
// forcing play() and retry on the first interaction / when the tab is shown.
// ==========================================
(function () {
    var heroVideo = document.querySelector('.hero-video');
    if (!heroVideo) return;

    // muted is mandatory for autoplay on iOS/Android
    heroVideo.muted = true;
    heroVideo.setAttribute('muted', '');
    heroVideo.playsInline = true;

    var heroPoster = document.getElementById('heroPoster');
    var snap = document.querySelector('.home-snap-container');
    var started = false;

    function tryPlay() {
        if (started) return;
        var p = heroVideo.play();
        if (p && typeof p.catch === 'function') {
            // Blocked (e.g. iOS Low Power Mode) — swallow; a later gesture retries
            p.catch(function () {});
        }
    }

    // The video is genuinely playing → fade the poster and stop retrying.
    function onPlaying() {
        started = true;
        if (heroPoster) heroPoster.classList.add('is-hidden');
        removeGestureRetries();
    }

    // iOS Low Power Mode refuses autoplay but DOES allow play() from a real
    // user gesture. Keep retrying on every gesture (tap, scroll of the snap
    // container, key) until the video actually starts — then clean up.
    var gestureEvents = ['touchstart', 'pointerdown', 'click', 'keydown'];
    function onVisible() { if (!document.hidden) tryPlay(); }
    function addGestureRetries() {
        gestureEvents.forEach(function (ev) { document.addEventListener(ev, tryPlay, { passive: true }); });
        window.addEventListener('scroll', tryPlay, { passive: true });
        if (snap) snap.addEventListener('scroll', tryPlay, { passive: true });
        document.addEventListener('visibilitychange', onVisible);
    }
    function removeGestureRetries() {
        gestureEvents.forEach(function (ev) { document.removeEventListener(ev, tryPlay); });
        window.removeEventListener('scroll', tryPlay);
        if (snap) snap.removeEventListener('scroll', tryPlay);
        document.removeEventListener('visibilitychange', onVisible);
    }

    heroVideo.addEventListener('playing', onPlaying);
    heroVideo.addEventListener('loadeddata', tryPlay);
    heroVideo.addEventListener('canplay', tryPlay);

    addGestureRetries();
    tryPlay();

    // Already playing from cache?
    if (!heroVideo.paused && heroVideo.currentTime > 0 && heroVideo.readyState > 2) onPlaying();
})();

// ==========================================
// CONSOLE BRANDING
// ==========================================
console.log('%cFIALLO', 'font-size: 48px; font-weight: bold; color: #000;');
console.log('%cThe Luxury Driver Sneaker', 'font-size: 16px; color: #666;');
console.log('%cMilan, Italy | felipefiallo.com', 'font-size: 12px; color: #999;');

// ==========================================
// KEYBOARD SHORTCUTS
// ==========================================
document.addEventListener('keydown', (e) => {
    // ESC to close menu
    if (e.key === 'Escape' && sideMenu && sideMenu.classList.contains('active')) {
        closeMenu();
    }
});

// ==========================================
// PREVENT ZOOM ON INPUT FOCUS (iOS)
// ==========================================
const inputs = document.querySelectorAll('input, textarea');
inputs.forEach(input => {
    input.addEventListener('focus', () => {
        input.style.fontSize = '16px';
    });
});

// ==========================================
// PAGE LOAD ANIMATION
// ==========================================
window.addEventListener('load', () => {
    document.body.classList.add('loaded');

    // Fade in elements
    const fadeElements = document.querySelectorAll('.fade-in');
    fadeElements.forEach((el, index) => {
        setTimeout(() => {
            el.style.opacity = '1';
        }, index * 100);
    });
});

// ==========================================
// EXPORT CART FOR USE IN OTHER PAGES
// ==========================================
if (typeof window !== 'undefined') {
    window.FialloCart = cart;
}

// ==========================================
// SET CURRENT YEAR IN FOOTER
// ==========================================
const currentYearElement = document.getElementById('current-year');
if (currentYearElement) {
    currentYearElement.textContent = new Date().getFullYear();
}

// ==========================================
// CREDITS CAROUSEL DRAG FUNCTIONALITY
// ==========================================
const carouselTrack = document.querySelector('.carousel-track');

if (carouselTrack) {
    let isDragging = false;
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = 0;
    let originalAnimation = carouselTrack.style.animation;

    // Get current translate value from animation
    function getCurrentTranslate() {
        const style = window.getComputedStyle(carouselTrack);
        const matrix = new DOMMatrix(style.transform);
        return matrix.m41;
    }

    function setSliderPosition() {
        carouselTrack.style.transform = `translateX(${currentTranslate}px)`;
    }

    function animation() {
        setSliderPosition();
        if (isDragging) requestAnimationFrame(animation);
    }

    // Touch events
    carouselTrack.addEventListener('touchstart', touchStart, { passive: true });
    carouselTrack.addEventListener('touchmove', touchMove, { passive: true });
    carouselTrack.addEventListener('touchend', touchEnd);

    // Mouse events
    carouselTrack.addEventListener('mousedown', touchStart);
    carouselTrack.addEventListener('mousemove', touchMove);
    carouselTrack.addEventListener('mouseup', touchEnd);
    carouselTrack.addEventListener('mouseleave', touchEnd);

    function touchStart(e) {
        isDragging = true;
        startX = getPositionX(e);
        prevTranslate = getCurrentTranslate();

        // Stop CSS animation
        carouselTrack.style.animation = 'none';
        currentTranslate = prevTranslate;

        animationID = requestAnimationFrame(animation);
        carouselTrack.style.cursor = 'grabbing';
    }

    function touchMove(e) {
        if (!isDragging) return;
        const currentX = getPositionX(e);
        const diff = currentX - startX;
        currentTranslate = prevTranslate + diff;

        // Limit the drag range
        const trackWidth = carouselTrack.scrollWidth / 2;
        if (currentTranslate > 0) currentTranslate = 0;
        if (currentTranslate < -trackWidth) currentTranslate = -trackWidth;
    }

    function touchEnd() {
        isDragging = false;
        cancelAnimationFrame(animationID);
        carouselTrack.style.cursor = 'grab';

        // Resume CSS animation after a short delay
        setTimeout(() => {
            carouselTrack.style.animation = originalAnimation;
        }, 2000);
    }

    function getPositionX(e) {
        return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
    }

    // Set initial cursor
    carouselTrack.style.cursor = 'grab';
}
